import { connect } from 'react-redux';
import React, { createContext, useContext, useState, useEffect, useCallback, useReducer } from 'react';
import Card from '@mui/material/Card';
import ReactDOM from 'react-dom';
import { Table, Column, Cell } from 'fixed-data-table-2';
import 'fixed-data-table-2/dist/fixed-data-table.css';
// import { ThemeContext } from './ApprovaIndex';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { Modal, Row, Col, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Chip from '@mui/material/Chip';
import { LaptopWindowsOutlined } from '@mui/icons-material';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import CircularProgress from '@mui/material/CircularProgress';
import DownloadIcon from '@mui/icons-material/Download';
import LoadingButton from '@mui/lab/LoadingButton';


const authentication = require('react-azure-adb2c2').default;

// Table data as a list of array.

// const api_base_url = "http://localhost:8080"
const api_base_url = "https://go.homestation.jp"

function DailySheet(props) {

    const [detail, setDetail] = useState([]);
  
    const [start, setStart] = useState(moment().format("YYYY/MM/1"));
    const [end, setEnd] = useState(moment().format("YYYY/MM/DD"));
    const [section_id, setSectionId] = useState(props.user_details.amSectionId);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [loadingDownloadTenpo, setLoadingDownloadTenpo] = useState(false);


    const [targetSectionId, setTargetSectionId] = useState(props.user_details.amSectionId);    // 店舗
    const [targetYearMonth, setTargetYearMonth] = useState(moment().format("YYYY-MM"));// 年月（YYYY-MM）
    const [targets, setTargets] = useState({
        all_count: 0,
        id: 0,
        kanri_count: 0,
        mediation_ippan: 0,
        mediation_kanri: 0,
        money: 0,
        owner_going: 0,
        section_id: 0,
        vacant: 0,
        vacant_contracts: 0,
        waters1: 0,
        waters2: 0,
        waters3: 0,
        waters4: 0,
    });

    const [loading, setLoading] = useState(false);

    const token = authentication.getAccessToken();
    //     // alert(application_id)
    //     // alert(path_no)
    //     // alert("この先のｄｂ更新処理からすること。この先はテストしていない。")

    //     const values = {application_id:application_id, path_no:path_no, approval_flg:approval_flg, user_id:props.user_details.id, comment:comments}

        
    //     var f = await fetch(`http://localhost:5000/v1/flw/authorizers/update`, { method: 'put', body: JSON.stringify(values), headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' } })
    //     var d = await f.json()

    //     setComments([])

    //     getData(application_id)

    // };


    const getData = async (section_id, ym) => {
        // alert("ws")

        setLoading(true)

        const url = api_base_url + `/rent-target/` + ym + `/` + section_id

        try {
            const res = await fetch(url, {
                method: 'GET',
                headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
            });

            const data = await res.json();  // ← これが必要
            console.log("aaaaaaaaaaaaaa", data)
            
            if(data){
                setTargets(data)  // ← dataをセット
            }else{
                setTargets({
                    all_count: 0,
                    id: 0,
                    kanri_count: 0,
                    mediation_ippan: 0,
                    mediation_kanri: 0,
                    money: 0,
                    owner_going: 0,
                    section_id: 0,
                    vacant: 0,
                    vacant_contracts: 0,
                    waters1: 0,
                    waters2: 0,
                    waters3: 0,
                    waters4: 0,
                    flg: 1,
                });
            }

            setLoading(false)
            

        } catch (error) {
            console.error('Delete error', error);
        }


    }

    const insertMypage = async () => {
        // alert("ws")

        // setLoading(true)

        const url = `http://localhost:8070/mypage/create`
        const values = {rent_response_id: 247766, buildings:[{tatemono_id: '100002', room_id:'0'}, {tatemono_id: '2350', room_id:'4'}]}
alert(url)
        try {
            const res =  await fetch(url, {
                method: 'POST',
                body: JSON.stringify(values), 
                headers: { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json', 'Content-Type': 'application/json'    },
            });

            const data = await res.text();  // 文字列なので .text()                                                                                             
            console.log("マイページアドレス：", data);     
            
            
            

        } catch (error) {
            console.error('Delete error', error);
        }


    }

    // ダウンロード
    const handleDownload = async () => {
        setLoadingDownload(true)
        if (token) {
            const u = api_base_url + `/crm/daily/report`//goapi

            const values = {section_id: section_id, start: moment(start).format("YYYY/MM/DD"), end: moment(end).format("YYYY/MM/DD")}
            const response =  await fetch(u, {
                method: 'POST',
                body: JSON.stringify(values), 
                headers: { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json', },
            });
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = "日報.xlsx";
            a.click();
            URL.revokeObjectURL(url);

            setLoadingDownload(false)
        }
    };

    // ダウンロード
    const handleDownloadTenpo = async () => {
        setLoadingDownloadTenpo(true)
        if (token) {
            const u = api_base_url + `/crm/daily/report/tenpo`//goapi

            const values = {section_id: section_id, start: moment(start).format("YYYY/MM/DD"), end: moment(end).format("YYYY/MM/DD")}
            const response =  await fetch(u, {
                method: 'POST',
                body: JSON.stringify(values), 
                headers: { 'Authorization': 'Bearer ' + token, 'Accept': 'application/json', },
            });
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = "日報全店.xlsx";
            a.click();
            URL.revokeObjectURL(url);

            setLoadingDownloadTenpo(false)
        }
    };

    useEffect(() => {
        getData(props.user_details.amSectionId, moment().format("YYYYMM"))
        
    }, [])


    const updateTarget = (key, value) => {
        setTargets(prev => ({ ...prev, [key]: value }));
        // console.log("targetstargets", targets)
    };

    const handleSave = () => {

        setLoading(true)

        if(targets.id > 0){
            Update()
            //更新
        }else{
            //新規
            Insert()
        }
    };

    const Insert = async () => {

        var target = {...targets}
        target.ym = parseInt(moment(targetYearMonth).format("YYYYMM"))
        target.section_id = targetSectionId
        // console.log("送信データ",target)
        const url = api_base_url + `/rent-target-insert`;
        var f = await fetch(url, { method: 'post', body: JSON.stringify(target), 
            headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
        
        }).then(async (response) => {

            var d = await response.json();

            console.log("rent-target-insert", d)
            setTargets(prev => ({
                ...prev,
                id: d.id
            }));

            setLoading(false)

            if (!response.ok) {
                console.error('サーバーエラー');
            }
        })
        .catch(error => {
            console.error('通信に失敗しました', error);
        });
    };

    const Update = async () => {

        const url = api_base_url + `/rent-target-update`;
        var f = await fetch(url, { method: 'put', body: JSON.stringify(targets), 
            headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },
        
        }).then(async (response) => {

            var d = await response.json();

            console.log("rent-target-update", d)

            setLoading(false)

            if (!response.ok) {
                console.error('サーバーエラー');
            }
        })
        .catch(error => {
            console.error('通信に失敗しました', error);
        });
    };


        return (
            <div>

                    
                <Grid container style={{margin:"10px"}}>
                    <Grid item xs={12} md={10} lg={8}>
                        <Card>
                            <Box display="flex" gap={2} alignItems="center" sx={{p:2}}>
                                    <TextField
                                        id="start"
                                        label="開始日"
                                        type="date"
                                        name="start"
                                        size="small"
                                        onChange={(e) => {
                                            setStart(e.target.value);
                                        }}
                                        value={moment(start).format("YYYY-MM-DD")}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        variant="standard"
                                    />

                                    <TextField
                                        id="end"
                                        label="終了日"
                                        type="date"
                                        name="end"
                                        size="small"
                                        onChange={(e) => {
                                            setEnd(e.target.value);
                                        }}
                                        value={moment(end).format("YYYY-MM-DD")}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        variant="standard"
                                    />



                                    {props.section_select && props.section_select.length ? <Autocomplete
                                        options={props.section_select.filter((a) => a.value == -1 || a.value == 1 || a.value == 2 || a.value == 3 || a.value == 4 || a.value == 6 || a.value == 17 || a.value == 47 || a.value == 26 || a.value == 37 || a.value == 55 || a.value == 62 || a.value == 67 || a.value == 10)}
                                        getOptionLabel={(option) => option.label}
                                        defaultValue={props.section_select.filter((a) => a.value === 1)[0]}
                                        value={props.section_select.filter((a) => a.value === section_id)[0]}
                                        onChange={(e, newValue) => {
                                            setSectionId(newValue ? newValue.value : -1);
                                        }}
                                        size="small"
                                        renderInput={(params) => <TextField style={{width:250, marginTop:5}}
                                            {...params} label="店舗を選択" />}

                                    /> : "aaa"}



                            <LoadingButton 
                                variant="contained" 
                                onClick={handleDownload} 
                                loading={loadingDownload} 
                                loadingPosition="start" 
                                color="primary" 
                                startIcon={<DownloadIcon />} 
                                style={{ float: "right", margin: 5 }}
                            >
                                日報
                            </LoadingButton>

                            <LoadingButton 
                                variant="contained" 
                                onClick={handleDownloadTenpo} 
                                loading={loadingDownloadTenpo} 
                                loadingPosition="start" 
                                color="primary" 
                                startIcon={<DownloadIcon />} 
                                style={{ float: "right", margin: 5 }}
                            >
                                日報全店
                            </LoadingButton>


                            {/*<Button 
                                variant="contained" 
                                onClick={insertMypage} 
                                loadingPosition="start" 
                                color="primary" 
                                startIcon={<DownloadIcon />} 
                                style={{ float: "right", margin: 5 }}
                            >
                                マイページ作成
                            </Button>*/}

                            </Box>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={10} lg={8}>

                        {/* ===== Loading 表示 ===== */}
                        {loading && (
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    bgcolor: "rgba(255,255,255,0.7)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    zIndex: 10,
                                    borderRadius: "4px",
                                }}
                            >
                                <CircularProgress />
                            </Box>
                        )}

                        <Card style={{marginTop:"10px"}}>
                            <Box sx={{ p: 2 }}>
                                <Typography variant="h6" sx={{ mb: 2 }}>
                                目標設定<span style={{color: "white"}}>{targets.id}</span>
                                </Typography>

                                <Box display="flex" gap={2} alignItems="center" sx={{ p: 2 }}>

                                    {/* ================= 店舗選択 ================= */}
                                    {props.section_select && props.section_select.length ? (
                                    <Autocomplete
                                        sx={{ width: 250 }}
                                        options={props.section_select}
                                        getOptionLabel={(option) => option.label}
                                        value={
                                            props.section_select.find((a) => a.value === targetSectionId) || null
                                        }
                                        onChange={(e, newValue) => {
                                            setTargetSectionId(newValue ? newValue.value : "");
                                            getData(newValue.value, moment(targetYearMonth).format("YYYYMM"))
                                        }}
                                        renderInput={(params) => (
                                        <TextField {...params} label="店舗を選択" size="small" />
                                        )}
                                    />
                                    ) : (
                                    "店舗データなし"
                                    )}

                                    {/* ================= 年月選択 ================= */}
                                    <TextField
                                        label="対象年月"
                                        type="month"
                                        size="small"
                                        value={targetYearMonth}
                                        onChange={(e) => {
                                            setTargetYearMonth(e.target.value);
                                            getData(targetSectionId, moment(e.target.value).format("YYYYMM"))
                                        }}
                                        InputLabelProps={{ shrink: true }}
                                        sx={{ width: 160 }}
                                    />
                                    
                                </Box>


                                <Grid container spacing={2}>

                                {/* ========= 目標件数 ========= */}
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextField
                                        fullWidth
                                        label="目標件数"
                                        variant="standard"
                                        type="number"
                                        value={targets.all_count}
                                        onChange={(e) => updateTarget("all_count", parseInt(e.target.value))}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">件</InputAdornment>,
                                        }}
                                    />
                                </Grid>

                                {/* ========= 目標金額 ========= */}
                                <Grid item xs={12} sm={6} md={4}>
                                    {/* <FormControl fullWidth variant="standard"> */}
                                    {/* <FormLabel>目標金額</FormLabel> */}
                                    <TextField
                                        fullWidth
                                        label="目標金額"
                                        variant="standard"
                                        type="number"
                                        value={targets.money}
                                        onChange={(e) => updateTarget("money", parseInt(e.target.value))}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">円</InputAdornment>,
                                        }}
                                    />
                                    {/* </FormControl> */}
                                </Grid>
                                </Grid>

                                <Grid container spacing={2}>

                                {/* ========= 管理成約目標 ========= */}
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextField
                                    fullWidth
                                    label="管理成約目標"
                                    variant="standard"
                                    type="number"
                                    value={targets.kanri_count}
                                    onChange={(e) => updateTarget("kanri_count", parseInt(e.target.value))}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">件</InputAdornment>,
                                    }}
                                    />
                                </Grid>

                                {/* ========= 入居率成約数目標件数 ========= */}
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextField
                                    fullWidth
                                    label="入居率成約数目標件数"
                                    variant="standard"
                                    type="number"
                                    value={targets.vacant}
                                    onChange={(e) => updateTarget("vacant", parseInt(e.target.value))}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">件</InputAdornment>,
                                    }}
                                    />
                                </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                {/* ========= オーナー訪問目標件数 ========= */}
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextField
                                    fullWidth
                                    label="オーナー訪問目標件数"
                                    variant="standard"
                                    type="number"
                                    value={targets.owner_going}
                                    onChange={(e) => updateTarget("owner_going", parseInt(e.target.value))}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">件</InputAdornment>,
                                    }}
                                    />
                                </Grid>

                                {/* ========= 管理受託目標件数 ========= */}
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextField
                                    fullWidth
                                    label="管理受託目標件数"
                                    variant="standard"
                                    type="number"
                                    value={targets.mediation_kanri}
                                    onChange={(e) => updateTarget("mediation_kanri", parseInt(e.target.value))}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">件</InputAdornment>,
                                    }}
                                    />
                                </Grid>

                                {/* ========= 一般受託目標件数 ========= */}
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextField
                                    fullWidth
                                    label="一般受託目標件数"
                                    variant="standard"
                                    type="number"
                                    value={targets.mediation_ippan}
                                    onChange={(e) => updateTarget("mediation_ippan", parseInt(e.target.value))}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">件</InputAdornment>,
                                    }}
                                    />
                                </Grid>


                                </Grid>

                                {/* ==================== 浄水器週別 ==================== */}
                                <Typography variant="subtitle1" sx={{ mt: 3, mb: 1 }}>
                                浄水器目標（週別）
                                </Typography>

                                <Grid container spacing={2}>
                                <Grid item xs={6} sm={3}>
                                    <TextField
                                    fullWidth
                                    label="第1週"
                                    type="number"
                                    variant="standard"
                                    value={targets.waters1}
                                    onChange={(e) => updateTarget("waters1", parseInt(e.target.value))}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">件</InputAdornment>,
                                    }}
                                    />
                                </Grid>

                                <Grid item xs={6} sm={3}>
                                    <TextField
                                    fullWidth
                                    label="第2週"
                                    type="number"
                                    variant="standard"
                                    value={targets.waters2}
                                    onChange={(e) => updateTarget("waters2", parseInt(e.target.value))}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">件</InputAdornment>,
                                    }}
                                    />
                                </Grid>

                                <Grid item xs={6} sm={3}>
                                    <TextField
                                    fullWidth
                                    label="第3週"
                                    type="number"
                                    variant="standard"
                                    value={targets.waters3}
                                    onChange={(e) => updateTarget("waters3", parseInt(e.target.value))}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">件</InputAdornment>,
                                    }}
                                    />
                                </Grid>

                                <Grid item xs={6} sm={3}>
                                    <TextField
                                    fullWidth
                                    label="第4週"
                                    type="number"
                                    variant="standard"
                                    value={targets.waters4}
                                    onChange={(e) => updateTarget("waters4", parseInt(e.target.value))}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">件</InputAdornment>,
                                    }}
                                    />
                                </Grid>
                                </Grid>

                            </Box>
                            {/* === 保存ボタン === */}
                            <Box sx={{ display: "flex", justifyContent: "flex-end", p:3 }}>
                                <Button 
                                    variant="contained" 
                                    color="success"
                                    onClick={handleSave}
                                >
                                    保存
                                </Button>
                            </Box>

                        </Card>
                    </Grid>


                </Grid>



            
            </div>
        );
};

const mapStateToProps = (state) => {
    return {
      user_details: state.masterReducer.user_details,
      users_select: state.masterReducer.users_select,

      sales_sheet_form: state.dashboard.sales_sheet_form,
    section_select: state.masterReducer.section_select,
    }
  }

export default connect(mapStateToProps)(DailySheet);